import { useCallback } from "react";
import useGA from "../../modules/fe-modules/GA/useGA";
import { useRouterContext } from "@rotorstudios/fe-modules";

import {
  GaEvent,
  GA_TOYOTA_FOR_YOU_CORE_PAGE,
  GaButtonName,
  GaSectionName,
} from "../../modules/fe-modules/GA/static";
import {
  MODAL_VEHICLE_SELECTOR,
  PAGE_CUSTOMISE,
  PAGE_GALLERY,
  PAGE_HOME,
  PAGE_NEXT_STEPS,
} from "../../modules/fe-modules/Router/static";
import { SIDEBAR_CONTENT } from "../../modules/Data/enums";
import { useDataContext } from "../../modules/Data/DataProvider";

export interface UseUiMMenuStickyProps {
  handleAllVehicles: () => void;
  handleCustomise: () => void;
  handleGallery: () => void;
  handleSaveAndShare: () => void;
  handleNextSteps: () => void;
  handleBackToHome: () => void;
}

const useUiMMenuSticky = (): UseUiMMenuStickyProps => {
  const { gotoPage } = useRouterContext();
  const { updateModalState, updateSidebarState } = useDataContext();
  const { triggerGAEvent } = useGA();

  const handleAllVehicles = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_ALL_VEHICLES,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    updateModalState({ id: MODAL_VEHICLE_SELECTOR });
  }, [triggerGAEvent, updateModalState]);

  const handleCustomise = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_CUSTOMISE,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    updateModalState({ id: PAGE_CUSTOMISE });
  }, [updateModalState, triggerGAEvent]);

  const handleGallery = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_GALLERY,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    updateModalState({ id: PAGE_GALLERY });
  }, [triggerGAEvent, updateModalState]);

  const handleSaveAndShare = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_SHARE,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    updateSidebarState(SIDEBAR_CONTENT.SHARE);
  }, [triggerGAEvent, updateSidebarState]);

  const handleNextSteps = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_NEXT_STEPS,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    gotoPage(PAGE_NEXT_STEPS, { search: globalThis.window?.location.search });
  }, [gotoPage, triggerGAEvent]);

  const handleBackToHome = useCallback(() => {
    triggerGAEvent(GaEvent.BUTTON_CLICKS, {
      buttonName: GaButtonName.NAVBAR_VEHICLE_HOME,
      viewName: GA_TOYOTA_FOR_YOU_CORE_PAGE,
      viewSection: GaSectionName.STICKY_MENU,
    });
    gotoPage(PAGE_HOME, { search: globalThis.window?.location.search });
  }, [gotoPage, triggerGAEvent]);

  return {
    handleAllVehicles,
    handleCustomise,
    handleGallery,
    handleSaveAndShare,
    handleNextSteps,
    handleBackToHome,
  };
};

export default useUiMMenuSticky;
